import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  AppBar as MuiAppBar,
  Toolbar,
  Grid,
  Container,
  Box,
  FormGroup,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import NavigationDrawer from '../navigation-drawer/container';
import NotificationDrawer from '../notification-drawer/container';
import {
  ThemeIcon,
  BurgerIcon,
  NotificationIcon,
  InactiveNotificationIcon,
} from '../../theme/styled-components';
import BackButton from '../back-button/component';
import NotificationBadge from '../notification-badge/container';
import styles from './styles';

function AppBar({
  classes,
  contact,
  handleOpenNavigationDrawer,
  handleOpenNotificationDrawer,
  handleGlobalThemeMode,
  prefersDarkMode,
}) {
  const [scrolled, setScrolled] = useState(false);

  const handleToogleTheme = useCallback((event) => {
    handleGlobalThemeMode(!event.target.checked);
    // if the switch is checked then lightmode is active
    if (event.target.checked) {
      localStorage.setItem('prefersDarkMode', JSON.stringify(false));
    } else {
      localStorage.removeItem('prefersDarkMode');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.onscroll = () => {
      if (window.scrollY > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
  }, []);

  return (
    <Box
      className={`${classes.root} ${
        scrolled ? 'appContent dropShadow' : 'appContent'
      }`}
    >
      <MuiAppBar
        color="default"
        component="div"
        position="static"
        elevation={0}
        data-testid="app-bar"
      >
        <Grid container>
          <Container maxWidth="lg">
            <Toolbar className={classes.toolBar}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs={2} sm={4}>
                  <BackButton />
                </Grid>
                <Grid item xs={1} sm={3} />
                <Grid item xs={9} sm={5}>
                  <Box className={classes.drawerLaunchContainer}>
                    <ThemeIcon />
                    <FormGroup className={classes.themeSwitchContainer}>
                      <FormControlLabel
                        control={
                          <Switch
                            onChange={handleToogleTheme}
                            checked={prefersDarkMode === false}
                          />
                        }
                      />
                    </FormGroup>
                    {!_.isEmpty(contact) ? (
                      <Box
                        className={classes.notificationIconContainer}
                        data-testid="notification-drawer-toggle"
                        onClick={(e) => handleOpenNotificationDrawer(e, true)}
                      >
                        <NotificationIcon aria-label="open drawer" />
                        <NotificationBadge />
                      </Box>
                    ) : (
                      <Box className={classes.notificationIconContainer}>
                        <InactiveNotificationIcon />
                      </Box>
                    )}
                    <BurgerIcon
                      aria-label="open drawer"
                      data-testid="navigation-drawer-toggle"
                      onClick={(e) => handleOpenNavigationDrawer(e, true)}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Toolbar>
          </Container>
        </Grid>
      </MuiAppBar>
      <NavigationDrawer />
      <NotificationDrawer />
    </Box>
  );
}

AppBar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  contact: PropTypes.object,
  handleOpenNavigationDrawer: PropTypes.func,
  handleOpenNotificationDrawer: PropTypes.func,
  handleGlobalThemeMode: PropTypes.func,
  prefersDarkMode: PropTypes.bool,
};

AppBar.defaultProps = {
  classes: {},
  contact: {},
  handleOpenNavigationDrawer: () => {},
  handleOpenNotificationDrawer: () => {},
  handleGlobalThemeMode: () => {},
  prefersDarkMode: false,
};

export default withStyles(styles)(AppBar);
